export default __webpack_public_path__ + "static/media/empty-budget-image.0845b711.svg";